import { render, staticRenderFns } from "./SaleOrdersReport.vue?vue&type=template&id=754feeb4&"
import script from "./SaleOrdersReport.vue?vue&type=script&lang=js&"
export * from "./SaleOrdersReport.vue?vue&type=script&lang=js&"
import style0 from "./SaleOrdersReport.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports